export default {
  "foot": {
    "title": "Century Games Oyuncuları",
    "p1": "Kullanıcı Kimliğinizi girin, yükleme ücretini ödeyin. Tutar doğrudan ilişkili hesabınızda güncellenecektir. Eğer görünmüyorsa lütfen oyunu yeniden yükleyin veya gerekiyorsa müşteri desteğiyle iletişime geçin.",
    "p2": "Herhangi bir sorunuz varsa lütfen müşteri desteğiyle iletişime geçmekten çekinmeyin. Desteğiniz için teşekkürler!",
    "copyright": "© Telif Hakkı 2024 Century Games'e aittir.",
    "service": "Kullanım Şartları",
    "policy": "Gizlilik Politikası",
    "descriptionTitle": "Bu Nasıl Çalışıyor?"
  },
  "accept": {
    "title": "Bu web sitesi, tarama deneyiminizi daha iyi hale getirmek için çerezleri kullanır. Web sitemizde neleri topladığımız hakkında bilgi için lütfen <a href=\"https://www.centurygames.com/privacy-policy/\" style=\"color: #58a8a5;\">Gizlilik Politikamızı</a> okuyun. Bu siteyi kullanmaya devam ederek, cihazınızda çerez saklayabileceğimizi ve çerezlere erişebileceğimizi kabul etmiş olursunuz.",
    "decline": "Reddet",
    "accept": "Kabul Et"
  },
  "game": {
    "inapptext": "Veya Oyun Üzerinden Giriş Yapın",
    "loginfail": "Giriş Başarısız",
    "logintip": "Oyun başlamazsa lütfen oyunu en son sürüme güncelleyin veya başka bir tarayıcı deneyin.",
    "reloadmsg": "Giriş sonucunu almak için lütfen 'Yeniden Yükle' düğmesine dokunun.",
    "reload": "Yeniden Yükle",
    "appnotice": "Oyun uygulaması üzerinden giriş yapmak istiyorsanız lütfen mağazayı açmak için harici bir tarayıcı kullanın.",
    "changeaccount": "Hesabınızdan çıkış yapmak istediğinizden emin misiniz?",
    "login": "Giriş Yap",
    "notice": "Uyarı",
    "confirm": "Onayla",
    "loginuserid": "Kullanıcı Kimliği",
    "palceholder": "Kullanıcı Kimliğini Girin",
    "okbtn": "Tamam",
    "loginbtn": "Oyun Üzerinden Giriş Yapın",
    "changebtn": "Veya Kullanıcı Kimliğinizle Giriş Yapın",
    "useTitle": "HESAP",
    "checkBtn": "Kontrol Et",
    "findid": "Kullanıcı Kimliğinizi bulamadınız mı?",
    "checktext": "Normalde ayarlarda bulunur, daha fazla destek için soru işaretine dokunun.",
    "username": "Takma Ad:",
    "userId": "Kullanıcı Kimliği :",
    "packageTitle": "YÜKLEME MİKTARI",
    "edit": "Düzenle",
    "paymentTitle": "ÖDEME YÖNTEMİ",
    "total": "Toplam",
    "goPay": "Şimdi Öde",
    "noSelectPackageTips": "Herhangi bir tutar seçmediniz",
    "payFail": "ÖDEME BAŞARISIZ",
    "camelPayfail": "Ödeme başarısız",
    "payFailTips1": "Lütfen Adyen Müşteri Desteği ile iletişime geçin",
    "payFailTips2": "Lütfen PayPal Müşteri Desteği ile iletişime geçin",
    "paySuccess": "ÖDEME BAŞARILI",
    "paySuccessTips2": "Satın alma işleminizi alamadığınız için Müşteri Desteği ile iletişime geçmeden önce oyunu yeniden yükleyin!",
    "camelPaySuccess": "Ödeme başarılı",
    "transactionId": "İşlem Kimliği",
    "paySuccessTips": "Ürün teslimatı biraz zaman alabilir, lütfen bekleyin",
    "deliveryFail": "TESLİMAT BAŞARISIZ",
    "deliveryFailTips": "Lütfen Müşteri Desteğiyle iletişime geçin",
    "orderTitle": "Siparişinizin özeti",
    "paidWith": "Ödeme Yöntemi",
    "orderID": "İşlem Kimliği",
    "payStatus": "Ödeme Durumu",
    "orderTotal": "Toplam Fiyat",
    "transactionDate": "İşlem Tarihi",
    "goOnPay": "Tekrar Satın Al",
    "getInvoice": "Fatura",
    "camelDeliveryFail": "Teslim edilmedi",
    "confirmOrder": "SİPARİŞ ONAYI",
    "confirmFollow": "Lütfen şunları onaylayın:",
    "nickname": "Takma Ad",
    "packageName": "Ögeler",
    "totalPayment": "Toplam Fiyat",
    "confirmPayWith": "Ödeme Yöntemi",
    "confirmAndGoOn": "Onayla ve Ödemeye Devam Et",
    "orderCancel": "İptal",
    "getInvoiceTitle": "E-POSTA İLE GÖNDER",
    "getInvoiceTips": "Faturayı e-postayla almak istiyorsanız lütfen bir e-posta adresi girin.",
    "getInvoiceTips1": "Faturayı almak için e-postanızı girin",
    "getInvoiceTips2": "E-posta adresinizi toplamamızı ve saklamamızı kabul edin.",
    "getInvoiceTips3": "Oyunlarımıza ilişkin indirimler, promosyonlar ve daha fazlası hakkında e-posta almayı kabul edin.",
    "invoiceSend": "Gönder",
    "sendSuccess": "Fatura E-postası Gönderildi",
    "id404": "Kullanıcı Kimliği bulunamadı",
    "packageLoadingText": "Mağaza öğeleri güncelleniyor...",
    "taxTips": "Fiyata vergiler dahildir",
    "adyenTips": "Ödeme hizmeti, bankacılık lisansı altında faaliyet gösteren ve Hollanda Merkez Bankası tarafından denetlenen Adyen tarafından sağlanıyor. Sertifikalarına ilişkin sorularınız varsa lütfen <a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a> adresine bakın. Verilerinizi nasıl korudukları konusunda lütfen<a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and-disclaimer/privacy-policy</a> adresine bakın.",
    "paypalTips": "Ödeme hizmeti PayPal tarafından sağlanmaktadır. Verilerinizi nasıl korudukları konusunda lütfen <a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/c2/webapps/mpp/ua/privacy-full</a> adresine bakın.",
    "switchCountryTips": "Tercih ettiğiniz ülke/bölge: ${servercountry}. Ülkeyi ve para birimini değiştirmek ister misiniz?",
    "paypalBtn": "Şimdi Kartla Öde",
    "paypalOr": "Veya",
    "paypalCard1": "Kart Sahibi Adı (isteğe bağlı)",
    "paypalCard2": "Kart Sahibi Adı (isteğe bağlı)",
    "checkUserID": "Link",
    "success": "BAŞARILI",
    "changeCurrencyContent": "Bölgeyi ve para birimini oyun içi ayarınıza uyacak şekilde değiştirmek ister misiniz: ${servercountry}？",
    "productDescription": "Çiftlik Doları, oyundaki tüm paketleri ve fırsatları satın almak için kullanılabilen para eşdeğeridir.",
    "payButton": "ÖDE",
    "userIdNotice": "Lütfen önce oyun hesabınızı bağlamak için Kullanıcı Kimliğinizi girin",
    "account": "Hesap",
    "card": "Kart",
    "notification": "Hesabınızı bağlamak için Kullanıcı Kimliğinizi girin, istediğiniz öğeleri seçin ve tercih ettiğiniz ödeme yöntemiyle ödeme yapın. Oyunu yeniden yükledikten sonra, satın alınan öğeler hesabınızda kullanıma hazır olarak görünecektir.\n\nHerhangi bir sorunuz varsa lütfen oyundaki müşteri desteğiyle iletişime geçmekten çekinmeyin.",
    "rongluRank": "Fırın Seviyesi",
    "tips": "Nasıl kullanılır?",
    "checkTIps1": "<a :href=\"policyUrl\">\"Gizlilik Politikası\"</a>, <a :href=\"serviceURl\">\"Hizmet Şartları\"</a> ve <a :href=\"paymentURl\">\"Ödeme Şartları ve Koşulları\"</a>'nı okudum ve kabul ediyorum.",
    "checkTIps2": "Lütfen okuyun ve onay kutusunu işaretleyin",
    "selectTips": "(En son oyun içi satın alımın para birimi seçilecektir)",
    "koPayTips": "Banka kartınızda yabancı para birimi olarak Kore Wonu kullanılıyorsa, Dinamik Döviz Dönüşümü (DCC) hizmeti kullanılır ve bu web sitesi tarafından değil, üçüncü taraf bir aracı kurum tarafından ek bir işlem ücreti tahsil edilebilir.",
    "PayTips": ""
  },
  "invoice": {
    "title": "Fatura",
    "transactionId": "İşlem Kimliği",
    "transactionDate": "İşlem Tarihi",
    "totalAmount": "Toplam Miktar",
    "paymentMethod": "Ödeme Yöntemi",
    "description": "Açıklama",
    "game": "Oyun",
    "quantity": "Adet",
    "price": "Fiyat",
    "amount": "Miktar",
    "total": "Toplam Miktar",
    "footTitle": "Not",
    "footContent": "Century Games'i desteklediğiniz için teşekkür ederiz!",
    "button1": "Fatura Al",
    "button2": "Fişsiz Geri Dön",
    "giveupInvoice": "Siparişiniz için makbuz almayacaksınız. Onaylıyor musunuz?"
  },
  "payment": {
    "card": "Kredi kartı bankamatik kartı",
    "paypal": "PayPal"
  },
  "country": {
    "countryTitle1": "ÜLKE / BÖLGE",
    "Africa": "Afrika",
    "America": "Amerika",
    "Asia": "Asya",
    "Europe": "Avrupa",
    "Oceania": "Okyanusya",
    "ZA": "Güney Afrika",
    "US": "Amerika Birleşik Devletleri",
    "HK": "Hong Kong, Çin",
    "JP": "Japonya",
    "KR": "Kore",
    "SG": "Singapur",
    "SA": "Suudi Arabistan",
    "IQ": "Irak",
    "TW": "Tayland, Çin",
    "TH": "Tayland",
    "GB": "Birleşik Krallık",
    "AU": "Avustralya",
    "countryLanguage1": "DİL",
    "AE": "Birleşik Arap Emirlikleri",
    "DE": "Almanya",
    "PT": "Portekiz",
    "RU": "Rusya",
    "ES": "İspanya",
    "CH": "İsviçler",
    "TR": "Türkiye",
    "KW": "Kuveyt",
    "QA": "Katar",
    "PL": "Polonya",
    "ID": "Endonezya",
    "IT": "İtalya",
    "IN": "Hindistan",
    "FR": "Fransa",
    "CA": "Kanada",
    "NL": "Hollanda",
    "AT": "Avusturya",
    "RS": "Sırbistan",
    "SE": "İsveç",
    "MY": "Malezya",
    "BE": "Belçika",
    "DK": "Danimarka",
    "FI": "Finlandiya",
    "PH": "Filipin",
    "NO": "Norveç",
    "BR": "Brezilya",
    "NZ": "Yeni Zelanda",
    "UA": "Ukranya",
    "RO": "Romanya"
  },
  "extra_info": {
    "kingdom": "Eyalet: #"
  },
  "adyen": {
    "note": "Ödeme hizmeti Adyen tarafından sağlanmakta olup, yurt içi ve yurt dışı kart ödemelerini destekleyen uluslararası kredi kartı kuruluşlarından en üst düzey PCI-DSS sertifikasına sahip, güvenli işlemler sunmaktadır.",
    "note2": "Not: Ödeme kartı bilgilerinizi gelecekteki ödemeleriniz için geçerli tarayıcınıza kaydetmek için \"Bir sonraki ödemem için kaydet\" seçeneğini işaretleyin."
  },
  "pay": {
    "error1": "Eğer bir şey yanlış giderse lütfen daha sonra tekrar deneyin veya başka bir ödeme yöntemi kullanın. Daha fazla sorunuz varsa lütfen müşteri desteğiyle iletişime geçin."
  },
  "meta": {
    "title": "Family Farm Adventure Mağazası",
    "description": "Family Farm Adventure Mağazası, Family Farm Adventure'ın resmi mağazasıdır ve oyunculara indirimli bir yükleme kanalı ve oyun içi paketler sunar.",
    "keywords": "çiftlik, yetiştirme, pazar, yükseltme, keşif, harita, karakter, seviye, simülasyon, strateji, öde, mağaza, yükleme, ödeme"
  }
};


// WEBPACK FOOTER //
// ./src/lang/TR.js